app.factory('httpResponseInterceptor', ['$q', '$location',
    function ($q, $location) {
        return {
            responseError: function (resp) {
                if (resp.status === 401) {
                    $location.path('/login');
                }
                return $q.reject(resp);
            }
        };
    }]);